import React, {Component} from 'react';
import CommonUtils from '../utils/CommonUtils';
import '../styles/RechargeView.css';

class RechargeView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            data: []
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(JSON.stringify(nextProps.data) !== JSON.stringify(prevState.data)) {
            return {
                data: nextProps.data
            }
        }
        return null
    }
    
    render() {
        const { data } = this.state
        const { handleRecharge } = this.props

        return (
            <div className='view-recharge'>
                <div className="title">
                    <i className='iconfont icon-31'></i>
                    <span> 优惠充值</span>
                    <span className="sub"> (充值余额全国门店通用)</span>
                </div>
                <div className='wrapper-recharge-rule'>
                    {data.map((rule, index) => {
                        let realAmount = rule.giftAmount ? rule.giftAmount + rule.rechargeAmount : rule.rechargeAmount
                        let name = rule.name ? rule.name : `充${rule.rechargeAmount}得${realAmount}`
                        return (
                            <div key={rule.id} className='recharge-rule' onClick={() => {handleRecharge(rule.id)}}>
                                <div className='name word-ellipsis'>{name}</div>
                                <div className='price word-ellipsis'>￥{rule.rechargeAmount}</div>
                                <div className={`tag${CommonUtils.isNotEmpty(rule.label)?'':' hidden'}`}>{rule.label}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}

export default RechargeView;


// WEBPACK FOOTER //
// ./src/components/RechargeView.js